// The full-window background behind logged-out screens on desktop.
// Replace brand-ground.png with the real artwork; see README.md in this
// folder for the spec. The placeholder is the app's own ornament image.
import brandGround from './brand-ground.png';

export default brandGround as string;
